import React from 'react';
import { Contact, ContactWithDetails } from '../../../crm/components/contacts/types';
import { FormErrors } from '../../../types';
import { validateRequired } from '../../../utils/validation';
import CategoryDropdown from './CategoryDropdown';
import '../../../components/common/CRMForm.css';

interface ContactInfoSectionProps {
  contactData: Omit<Contact, 'id' | 'dateCreated' | 'dateUpdated' | 'whoUpdated'>;
  errors: FormErrors;
  onChange: (field: keyof Contact, value: string | number) => void;
  isTypeDisabled?: boolean;
  isReadOnly?: boolean;
  existingContacts?: ContactWithDetails[];
  currentContactId?: number | null;
}

const ContactInfoSection: React.FC<ContactInfoSectionProps> = ({
  contactData,
  errors,
  onChange,
  isTypeDisabled = false,
  isReadOnly = false,
  existingContacts = [],
  currentContactId = null,
}) => {
  const handleInputChange = (field: keyof Contact, value: string | number) => {
    onChange(field, value);
  };

  return (
    <div className="form-section-content">
      <div className="app-form-row">
        <div className="app-form-group">
          <label htmlFor="type" className="app-form-label required">
            Contact Type
          </label>
          <CategoryDropdown
            parentType="contact"
            value={contactData.typeId}
            onChange={(value) => handleInputChange('typeId', value)}
            className={errors.type ? 'error' : ''}
            required={true}
            disabled={isTypeDisabled}
            existingContacts={existingContacts}
            currentContactId={currentContactId}
          />
          {errors.type && <div className="app-form-error">{errors.type}</div>}
        </div>
      </div>

      <div className="app-form-row">
        <div className="app-form-group">
          <label htmlFor="firstName" className="app-form-label required">
            First Name
          </label>
          <input
            id="firstName"
            type="text"
            className={`app-form-input ${errors.firstName ? 'error' : ''}`}
            value={contactData.firstName}
            onChange={(e) => handleInputChange('firstName', e.target.value)}
            placeholder="Enter first name"
            disabled={isReadOnly}
          />
          {errors.firstName && <div className="app-form-error">{errors.firstName}</div>}
        </div>

        <div className="app-form-group">
          <label htmlFor="lastName" className="app-form-label required">
            Last Name
          </label>
          <input
            id="lastName"
            type="text"
            className={`app-form-input ${errors.lastName ? 'error' : ''}`}
            value={contactData.lastName}
            onChange={(e) => handleInputChange('lastName', e.target.value)}
            placeholder="Enter last name"
            disabled={isReadOnly}
          />
          {errors.lastName && <div className="app-form-error">{errors.lastName}</div>}
        </div>
      </div>

      <div className="app-form-group">
        <label htmlFor="businessName" className="app-form-label">
          Business Name
        </label>
        <input
          id="businessName"
          type="text"
          className="app-form-input"
          value={contactData.businessName}
          onChange={(e) => handleInputChange('businessName', e.target.value)}
          placeholder="Enter business name (optional)"
          disabled={isReadOnly}
        />
      </div>

      <div className="app-form-group">
        <label htmlFor="notes" className="app-form-label">
          Notes
        </label>
        <textarea
          id="notes"
          className="app-form-textarea"
          value={contactData.notes}
          onChange={(e) => handleInputChange('notes', e.target.value)}
          placeholder="Enter any additional notes (optional)"
          rows={4}
          disabled={isReadOnly}
        />
      </div>
    </div>
  );
};

export default ContactInfoSection;
